export const ErrorTemplate = `
    <div class="alert alert-danger" role="alert">
        {{text}}
    </div>
`;
